import manager from '@mailobj-browser/front/js/contracts/manager.js'
import body from '@mailobj-browser/front/js/tree/body.js'
import globals from '#utilities/js/ea/globals.js'

export default template => {
  queueMicrotask(async () => {
    const { innerHTML, ownerDocument } = template
    const target = body(innerHTML, ownerDocument)
    
    await manager.trigger(target)
    globals.ea_screen_adjust()
  })
}
